import { useEffect, useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { TreeSelect } from "antd";
import trans from "../../../utils";
import { usePlayback } from "../../../context/VideoPlayback";

const VehicleSelect = ({
  maxCount,
  vehicles,
  feeds,
  setSelectedFeeds,
  selectedValues,
  isLoading,
}) => {
  let MAX_COUNT = 4;
  switch (maxCount) {
    case 1:
      MAX_COUNT = 1;
      break;
    case 2:
      MAX_COUNT = 4;
      break;
    case 3:
      MAX_COUNT = 6;
      break;
    case 4:
      MAX_COUNT = 9;
      break;
    case 5:
      MAX_COUNT = 8;
      break;
    default:
      MAX_COUNT = 4;
      break;
  }

  const [value, setValue] = useState([]);

  useEffect(() => {
    setValue(selectedValues);
  }, [selectedValues]);

  const getActiveParent = () => {
    return value.length > 0 ? value[0].split("-")[0] : null;
  };

  const parentGroup = getActiveParent();

  const buildTreeData = () => {
    return vehicles.map((parent) => {
      const isDisabled = parentGroup && parent.value !== parentGroup;

      return {
        ...parent,
        disabled: isDisabled,
        children: parent.children.map((child) => ({
          ...child,
          disabled: parentGroup && !child.value.startsWith(parentGroup), // Disable other parents' children only
        })),
      };
    });
  };

  const onChange = (newValue, label, extra) => {
    let updatedValues;

    if (extra.triggerNode && extra.triggerNode.props.children) {
      // Parent node clicked
      const parentValue = extra.triggerNode.props.value;
      const parent = vehicles.find((v) => v.value === parentValue);

      if (parent) {
        // Start from current state to allow accumulation
        updatedValues = [...value];

        const availableChildren = parent.children.map((child) => child.value);

        const remainingSlots = MAX_COUNT - updatedValues.length;

        const newSelections = availableChildren.filter(
          (child) => !updatedValues.includes(child)
        );

        const channelsToAdd = newSelections.slice(0, remainingSlots);

        updatedValues = Array.from(
          new Set([...updatedValues, ...channelsToAdd])
        );
      } else {
        // Fallback to newValue if something goes wrong
        updatedValues = [...newValue];
      }
    } else {
      // Child node clicked → trust the UI selection fully
      updatedValues = [...newValue];
    }

    // Determine active parent from selection
    const newParentGroup =
      updatedValues.length > 0 ? updatedValues[0].split("-")[0] : null;

    // Filter out channels not belonging to the active parent
    const filteredValues = updatedValues.filter((val) =>
      val.startsWith(newParentGroup)
    );

    if (filteredValues.length <= MAX_COUNT) {
      setValue(filteredValues);

      const selectedUrls = feeds.filter((feed) =>
        filteredValues.includes(`${feed.vehicle}-${feed.channel}`)
      );

      setSelectedFeeds(selectedUrls);
    }
  };

  const suffix = (
    <>
      <span>
        {value.length} / {MAX_COUNT}
      </span>
      <DownOutlined />
    </>
  );

  return (
    <TreeSelect
      allowClear
      treeData={buildTreeData()}
      value={value}
      onChange={onChange}
      multiple
      maxTagCount={"responsive"}
      style={{ width: "100%" }}
      suffixIcon={suffix}
      treeCheckable
      placeholder={trans("Please select")}
      showCheckedStrategy={TreeSelect.SHOW_CHILD}
      loading={isLoading || false}
    />
  );
};

export default VehicleSelect;
